export const CommonSense = {
    name: "Common Sense",
    run: (fact, emit) => {
        if (!fact.output) {
            emit("The designed gearbox doesn't have an output stage, please add one.")
        }
        if (!fact.input) {
            emit("The designed gearbox doesn't have an input stage, please add one.")
        }
        if (fact.stages.length === 0) {
            emit("The designed gearbox doesn't have any reduction stages, please add at least one.", "warning")
        }
    }
}



